import React from 'react';
import { PoweredByComponent,
         VerificationService,
         getSafe,
} from '@sheerid/jslib';
import { FormattedHTMLMessage } from 'react-intl';
import { PrivacyPolicy } from '../PrivacyPolicy';

interface FormFooterProps {
    verificationService: VerificationService;
    children?: any;
}

const FormFooterComponent = ({ verificationService, children }: FormFooterProps) => {
    const countryChoice = getSafe<string>(() => verificationService.viewModel.countryChoice.value, undefined);

    return (
        <div className="sid-footer sid-h-small-text sid-l-space-top-md" role="contentinfo">
            <div className="sid-footer__shield">
                <img
                    title="Powered by SheerID"
                    alt="design element"
                    src="https://assets-resources.sheerid.com/common/images/2018/icons/shield-check.svg"
                />
            </div>
            <div>
                <div className="sid-footer__one">
                    {children ? children
                    :
                        (<div>
                            <FormattedHTMLMessage
                                id="infoShared"
                                defaultMessage={'Information entered here will be used for verification purposes and shared with {companyName}. '}
                                values={{
                                    companyName: getSafe<string>(() => verificationService.programTheme.intl.messages.companyName, '{Company}'),
                                }}
                            />
                            {
                                typeof countryChoice === 'string' && countryChoice.length > 0 && countryChoice !== 'US' ?
                                    <FormattedHTMLMessage
                                        id="informationTransferredToUS"
                                        defaultMessage=
                                            "Your information will be transferred to the United States and will be treated according to SheerID’s privacy policy."
                                    />
                                : null
                            }
                        </div>)
                    }
                </div>
                <div className="sid-footer__two">
                    <PoweredByComponent verificationService={verificationService} />
                </div>
                <PrivacyPolicy />
            </div>
        </div>
    );
};

export { FormFooterComponent };
